import { Injectable, computed, signal } from '@angular/core'
import { User } from 'oidc-client-ts'

/**
 * Holds the raw OIDC user (including access/id tokens) in memory, outside
 * any NgRx store, so tokens are never serialized into store snapshots
 * (Redux DevTools, state dumps, etc.).
 */
@Injectable({ providedIn: 'root' })
export class OidcTokenService {
  readonly #user = signal<User | null>(null)

  readonly isLoggedIn = computed(() => this.#user() !== null)
  readonly formattedToken = computed(() => {
    const user = this.#user()
    return user ? `${user.token_type} ${user.access_token}` : null
  })
  readonly idToken = computed(() => this.#user()?.id_token ?? null)

  setUser(user: User): void {
    this.#user.set(user)
  }

  clearUser(): void {
    this.#user.set(null)
  }
}
